'use strict';

module.exports = {
  template: require('./cn-table.html'),
  controller: require('./cn-table.controller.js'),
  controllerAs: 'vm',

  bindings: {
    headers: '<',
    src: '<',
    actions: '<',
    dateTimeField: '@',
    onRowClick: '<',
    specialActions: '<',
    followUp: '<',
    initialAssessment: '<',
    performanceAssessment: '<',
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-table/index.js
 ** module id = 74
 ** module chunks = 0
 **/